<template>
    <article v-if="chave != null" class="panel">
        <div v-if="panelHeader" class="panel-heading has-text-centered">
            {{ $t('HISTORICO.TITULO') }}
        </div>
        <div class="panel-block">
            <slot name="trigger" :open="showModal">
                <b-button native-type="button" type="is-info" expanded icon-left="clock" @click="showModal" :title="$t('HISTORICO.TITULO')">
                    {{ buttonLabel }}
                </b-button>
            </slot>
        </div>
        <b-modal :active="modalHistoricoIsOpened" @update:active="modalHistoricoIsOpened = $event" has-modal-card trap-focus aria-role="dialog" aria-modal>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $t('HISTORICO.INFORMACOES') }}</p>
                </header>
                <section class="modal-card-body">
                    <table class="table is-fullwidth">
                        <tr v-for="(item, index) in lista" v-bind:key="index">
                            <td>
                                <h4>{{ item.descricao }}</h4>
                                <small v-if="item.observacoes"> <b>Obs:</b> {{ item.observacoes }} </small>
                            </td>
                            <td>
                                <span
                                    ><b>{{ item.usuarioNome }}</b> ({{ item.usuarioId }})</span
                                >
                            </td>
                            <td>
                                <span>{{ $formatDate(item.dataHora, 'DD/MM/YYYY HH:mm') }}</span>
                            </td>
                        </tr>
                    </table>
                </section>
                <footer class="modal-card-foot">
                    <button class="button is-pulled-right" type="button" @click="modalHistoricoIsOpened = false">{{ $t('HISTORICO.FECHAR') }}</button>
                </footer>
            </div>
        </b-modal>
    </article>
</template>

<script>
import http from '@/http'

export default {
    props: {
        tabela: String,
        chave: Number,
        toggle: Boolean,
        agendaLog: {
            type: Boolean,
            default: false,
        },
        panelHeader: {
            type: Boolean,
            default: true,
        },
        buttonLabel: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            lista: [],
        }
    },
    watch: {
        modalHistoricoIsOpened() {
            if (!this.modalHistoricoIsOpened) {
                this.$emit('close')
            }
        },
    },
    created() {
        if (this.$props.toggle) {
            this.showModal()
        }
    },
    computed: {
        modalHistoricoIsOpened: {
            get() {
                return this.$store.state.componentes.modalHistoricoIsOpened
            },
            set(value) {
                return this.$store.commit('componentes/SET_MODAL_HISTORICO', value)
            },
        },
    },
    methods: {
        showModal() {
            this.modalHistoricoIsOpened = !this.modalHistoricoIsOpened
            if (this.modalHistoricoIsOpened && this.lista.length == 0) {
                this.loadAsyncData()
            }
        },
        loadAsyncData() {
            if (this.agendaLog) {
                http.get('/api/manutencao/LogAgenda?chave=' + this.$props.chave)
                    .then((res) => res.data)
                    .then((data) => {
                        if (data != null) {
                            this.lista = data
                        }
                    })
            } else {
                http.get('/api/manutencao/log?tabela=' + this.$props.tabela + '&chave=' + this.$props.chave)
                    .then((res) => res.data)
                    .then((data) => {
                        if (data != null) {
                            this.lista = data
                        }
                    })
            }
        },
    },
}
</script>
